import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography
} from '@material-ui/core';
import { format, parseISO } from 'date-fns';


interface IExclusionNote {
  name: string;
  checked: boolean;
  value?: string;
}

const RequestedPromotionDetails = ({
  handleClose,
  open,
  selectedPromotion
}) => {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Promotion Summary</DialogTitle>
      <Divider className="mb-3" />

      <DialogContent>
        <DialogContentText>
          <>
            {!!selectedPromotion.title.length &&
              <>
                <Typography variant="h5" className="font-bold text-13">
                  Promotion Title
                </Typography>
                <ul className="my-2 text-13 pl-6">
                  <li>{selectedPromotion.title}</li>
                </ul>
              </>
            }
            {(!!selectedPromotion.discountType.name.length  ||  selectedPromotion.freeShipping.active) &&
            <>
              <Typography variant="h5" className="font-bold text-13">
                Discount Type
              </Typography>
              {selectedPromotion.percentageOff.isActive &&
                <>
                  {!!selectedPromotion.percentageOff.discount.length &&
                    <ul className="my-2 text-13 pl-6">
                      <li>{selectedPromotion.percentageOff.discount} OFF</li>
                    </ul>
                  }
                  {!!selectedPromotion.percentageOff.appliesTo.name.length &&
                  <>
                    <Typography variant="h5" className="font-bold text-13">
                      Applies To:
                    </Typography>
                    {
                      (
                        selectedPromotion.percentageOff.appliesTo.name === 'Storewide'
                        || selectedPromotion.percentageOff.appliesTo.name === 'All Products'
                        || selectedPromotion.percentageOff.appliesTo.name === 'All Treatments'
                      ) ?
                        <ul className="my-2 text-13 pl-6">
                          <li>{selectedPromotion.percentageOff.appliesTo.name}</li>
                        </ul>
                        :
                        <ul className="my-2 text-13 pl-6">
                          {selectedPromotion.percentageOff.appliesTo.isCategories &&
                          <>
                            {!!selectedPromotion.percentageOff.appliesTo.value.categories.length &&
                              <li>
                                {'Categories: '}
                                {selectedPromotion.percentageOff.appliesTo.value.categories.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.percentageOff.appliesTo.value.categories.length > 1 &&
                                      selectedPromotion.percentageOff.appliesTo.value.categories.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            }
                          </>
                          }
                          {selectedPromotion.percentageOff.appliesTo.isListings &&
                            <>
                              <li>
                                {'Listings: '}
                                {selectedPromotion.percentageOff.appliesTo.value.listings.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.percentageOff.appliesTo.value.listings.length > 1 &&
                                      selectedPromotion.percentageOff.appliesTo.value.listings.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            </>
                          }
                        </ul>
                    }
                  </>
                  }
                  {selectedPromotion.percentageOff.notAppliesTo.name !== 'None' &&
                  <>
                    <Typography variant="h5" className="font-bold text-13">
                      Does Not Applies To:
                    </Typography>
                    {
                      (
                        selectedPromotion.percentageOff.notAppliesTo.name === 'All Products'
                        || selectedPromotion.percentageOff.notAppliesTo.name === 'All Treatments'
                      ) ?
                        <ul className="my-2 text-13 pl-6">
                          <li>{selectedPromotion.percentageOff.notAppliesTo.name}</li>
                        </ul>
                        :
                        <ul className="my-2 text-13 pl-6">
                          {selectedPromotion.percentageOff.notAppliesTo.isCategories &&
                          <>
                            {!!selectedPromotion.percentageOff.notAppliesTo.value.categories.length &&
                              <li>
                                {'Categories: '}
                                {selectedPromotion.percentageOff.notAppliesTo.value.categories.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.percentageOff.notAppliesTo.value.categories.length > 1 &&
                                      selectedPromotion.percentageOff.notAppliesTo.value.categories.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            }
                          </>
                          }
                          {selectedPromotion.percentageOff.notAppliesTo.isListings &&
                            <>
                              <li>
                                {'Listings: '}
                                {selectedPromotion.percentageOff.notAppliesTo.value.listings.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.percentageOff.notAppliesTo.value.listings.length > 1 &&
                                      selectedPromotion.percentageOff.notAppliesTo.value.listings.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            </>
                          }
                        </ul>
                    }
                  </>
                  }
                </>
              }
              {selectedPromotion.dollarOff.isActive &&
                <>
                  {!!selectedPromotion.dollarOff.discount.length &&
                    <ul className="my-2 text-13 pl-6">
                      <li>
                        {selectedPromotion.dollarOff.discount}{' OFF '}
                        {selectedPromotion.dollarOff.discountTo.length &&
                          <>
                            {
                              selectedPromotion.dollarOff.discountTo === 'by_fixed'
                                ? 'for each item'
                                : 'for whole cart'
                            }
                          </>
                        }
                      </li>
                    </ul>
                  }
                  {!!selectedPromotion.dollarOff.appliesTo.name.length &&
                  <>
                    <Typography variant="h5" className="font-bold text-13">
                      Applies To:
                    </Typography>
                    {
                      (
                        selectedPromotion.dollarOff.appliesTo.name === 'Storewide'
                        || selectedPromotion.dollarOff.appliesTo.name === 'All Products'
                        || selectedPromotion.dollarOff.appliesTo.name === 'All Treatments'
                      ) ?
                        <ul className="my-2 text-13 pl-6">
                          <li>{selectedPromotion.dollarOff.appliesTo.name}</li>
                        </ul>
                        :
                        <ul className="my-2 text-13 pl-6">
                          {selectedPromotion.dollarOff.appliesTo.isCategories &&
                          <>
                            {!!selectedPromotion.dollarOff.appliesTo.value.categories.length &&
                              <li>
                                {'Categories: '}
                                {selectedPromotion.dollarOff.appliesTo.value.categories.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.dollarOff.appliesTo.value.categories.length > 1 &&
                                      selectedPromotion.dollarOff.appliesTo.value.categories.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            }
                          </>
                          }
                          {selectedPromotion.dollarOff.appliesTo.isListings &&
                            <>
                              <li>
                                {'Listings: '}
                                {selectedPromotion.dollarOff.appliesTo.value.listings.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.dollarOff.appliesTo.value.listings.length > 1 &&
                                      selectedPromotion.dollarOff.appliesTo.value.listings.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            </>
                          }
                        </ul>
                    }
                  </>
                  }
                  {selectedPromotion.dollarOff.notAppliesTo.name !== 'None' &&
                  <>
                    <Typography variant="h5" className="font-bold text-13">
                      Does Not Applies To:
                    </Typography>
                    {
                      (
                        selectedPromotion.dollarOff.notAppliesTo.name === 'All Products'
                        || selectedPromotion.dollarOff.notAppliesTo.name === 'All Treatments'
                      ) ?
                        <ul className="my-2 text-13 pl-6">
                          <li>{selectedPromotion.dollarOff.notAppliesTo.name}</li>
                        </ul>
                        :
                        <ul className="my-2 text-13 pl-6">
                          {selectedPromotion.dollarOff.notAppliesTo.isCategories &&
                          <>
                            {!!selectedPromotion.dollarOff.notAppliesTo.value.categories.length &&
                              <li>
                                {'Categories: '}
                                {selectedPromotion.dollarOff.notAppliesTo.value.categories.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.dollarOff.notAppliesTo.value.categories.length > 1 &&
                                      selectedPromotion.dollarOff.notAppliesTo.value.categories.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            }
                          </>
                          }
                          {selectedPromotion.dollarOff.notAppliesTo.isListings &&
                            <>
                              <li>
                                {'Listings: '}
                                {selectedPromotion.dollarOff.notAppliesTo.value.listings.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.dollarOff.notAppliesTo.value.listings.length > 1 &&
                                      selectedPromotion.dollarOff.notAppliesTo.value.listings.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            </>
                          }
                        </ul>
                    }
                  </>
                  }
                </>
              }
              {selectedPromotion.fixedPrice.isActive &&
                <>
                  {!!selectedPromotion.fixedPrice.price.length &&
                    <ul className="my-2 text-13 pl-6">
                      <li>Fixed price {selectedPromotion.fixedPrice.price}</li>
                    </ul>
                  }
                  {!!selectedPromotion.fixedPrice.appliesTo.name.length &&
                  <>
                    <Typography variant="h5" className="font-bold text-13">
                      Applies To:
                    </Typography>
                    {
                      (
                        selectedPromotion.fixedPrice.appliesTo.name === 'Storewide'
                        || selectedPromotion.fixedPrice.appliesTo.name === 'All Products'
                        || selectedPromotion.fixedPrice.appliesTo.name === 'All Treatments'
                      ) ?
                        <ul className="my-2 text-13 pl-6">
                          <li>{selectedPromotion.fixedPrice.appliesTo.name}</li>
                        </ul>
                        :
                        <ul className="my-2 text-13 pl-6">
                          {selectedPromotion.fixedPrice.appliesTo.isCategories &&
                          <>
                            {!!selectedPromotion.fixedPrice.appliesTo.value.categories.length &&
                              <li>
                                {'Categories: '}
                                {selectedPromotion.fixedPrice.appliesTo.value.categories.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.fixedPrice.appliesTo.value.categories.length > 1 &&
                                      selectedPromotion.fixedPrice.appliesTo.value.categories.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            }
                          </>
                          }
                          {selectedPromotion.fixedPrice.appliesTo.isListings &&
                            <>
                              <li>
                                {'Listings: '}
                                {selectedPromotion.fixedPrice.appliesTo.value.listings.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.fixedPrice.appliesTo.value.listings.length > 1 &&
                                      selectedPromotion.fixedPrice.appliesTo.value.listings.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            </>
                          }
                        </ul>
                    }
                  </>
                  }
                  {selectedPromotion.fixedPrice.notAppliesTo.name !== 'None' &&
                  <>
                    <Typography variant="h5" className="font-bold text-13">
                      Does Not Applies To:
                    </Typography>
                    {
                      (
                        selectedPromotion.fixedPrice.notAppliesTo.name === 'All Products'
                        || selectedPromotion.fixedPrice.notAppliesTo.name === 'All Treatments'
                      ) ?
                        <ul className="my-2 text-13 pl-6">
                          <li>{selectedPromotion.fixedPrice.notAppliesTo.name}</li>
                        </ul>
                        :
                        <ul className="my-2 text-13 pl-6">
                          {selectedPromotion.fixedPrice.notAppliesTo.isCategories &&
                          <>
                            {!!selectedPromotion.fixedPrice.notAppliesTo.value.categories.length &&
                              <li>
                                {'Categories: '}
                                {selectedPromotion.fixedPrice.notAppliesTo.value.categories.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.fixedPrice.notAppliesTo.value.categories.length > 1 &&
                                      selectedPromotion.fixedPrice.notAppliesTo.value.categories.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            }
                          </>
                          }
                          {selectedPromotion.fixedPrice.notAppliesTo.isListings &&
                            <>
                              <li>
                                {'Listings: '}
                                {selectedPromotion.fixedPrice.notAppliesTo.value.listings.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.fixedPrice.notAppliesTo.value.listings.length > 1 &&
                                      selectedPromotion.fixedPrice.notAppliesTo.value.listings.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            </>
                          }
                        </ul>
                    }
                  </>
                  }
                </>
              }
              {selectedPromotion.buyXGetY.isActive &&
                <>
                  {!!selectedPromotion.buyXGetY.customerBuys.minBuy.value.length &&
                    <ul className="my-2 text-13 pl-6">
                      <li>
                        Buy {selectedPromotion.buyXGetY.customerBuys.minBuy.value}{' '}
                        {
                          (selectedPromotion.buyXGetY.customerBuys.appliesTo.name === 'Storewide'
                            || selectedPromotion.buyXGetY.customerBuys.appliesTo.name === 'All Products'
                            || selectedPromotion.buyXGetY.customerBuys.appliesTo.name === 'All Treatments'
                          )
                            ?
                            selectedPromotion.buyXGetY.customerBuys.appliesTo.name
                            :
                            <>
                              {selectedPromotion.buyXGetY.customerBuys.appliesTo.value.categories.map((v) => v.name.trim()).join(', ')}{', '}
                              {selectedPromotion.buyXGetY.customerBuys.appliesTo.value.listings.map((v) => v.name.trim()).join(', ')}{', '}
                            </>
                        }
                        {!!selectedPromotion.buyXGetY.customerGet.quantity.length &&
                          <>
                            Get {selectedPromotion.buyXGetY.customerGet.quantity}{' '}
                            {selectedPromotion.buyXGetY.customerGet.appliesTo.value.categories.map((v) => v.name.trim()).join(', ')}{', '}
                            {selectedPromotion.buyXGetY.customerGet.appliesTo.value.listings.map((v) => v.name.trim()).join(', ')}
                          </>
                        }
                        {(!!selectedPromotion.buyXGetY.discountValue.name.length &&
                          !!selectedPromotion.buyXGetY.discountValue.value.length
                        ) &&
                          <>
                            {
                              (
                                selectedPromotion.buyXGetY.discountValue.name === 'Percentage OFF'
                                  || selectedPromotion.buyXGetY.discountValue.name === 'Dollar OFF'
                              ) ?
                                <>
                                  {'with '}{selectedPromotion.buyXGetY.discountValue.value}{' OFF'}
                                </>
                                :
                                <>
                                  {'with fixed price '}{selectedPromotion.buyXGetY.discountValue.value}
                                </>
                            }
                          </>
                        }
                      </li>
                    </ul>
                  }
                </>
              }
              {selectedPromotion.everyNth.isActive &&
              <>
                {(!!selectedPromotion.everyNth.discountOn.name.length &&
                  !!selectedPromotion.everyNth.discountOn.value.length
                ) &&
                <ul className="my-2 text-13 pl-6">
                  <li>
                    {selectedPromotion.everyNth.discountOn.value.includes('$') ?
                      <>
                        {`Every ${selectedPromotion.everyNth.discountOn.value} purchase amount `}
                      </>
                      :
                      <>
                        {`Every ${selectedPromotion.everyNth.discountOn.value} quantity of item `}
                      </>
                    }
                    {(!!selectedPromotion.everyNth.discountValue.name.length &&
                          !!selectedPromotion.everyNth.discountValue.value.length
                    ) &&
                    <>
                      {
                        (
                          selectedPromotion.everyNth.discountValue.name === 'Percentage OFF'
                                  || selectedPromotion.everyNth.discountValue.name === 'Dollar OFF'
                        ) ?
                          <>
                            {'with '}{selectedPromotion.everyNth.discountValue.value}{' OFF'}
                          </>
                          :
                          <>
                            {'with fixed price '}{selectedPromotion.everyNth.discountValue.value}
                          </>
                      }
                    </>
                    }
                  </li>
                </ul>
                }
                {!!selectedPromotion.everyNth.appliesTo.name.length &&
                  <>
                    <Typography variant="h5" className="font-bold text-13">
                      Applies To:
                    </Typography>
                    {
                      (
                        selectedPromotion.everyNth.appliesTo.name === 'Storewide'
                        || selectedPromotion.everyNth.appliesTo.name === 'All Products'
                        || selectedPromotion.everyNth.appliesTo.name === 'All Treatments'
                      ) ?
                        <ul className="my-2 text-13 pl-6">
                          <li>{selectedPromotion.everyNth.appliesTo.name}</li>
                        </ul>
                        :
                        <ul className="my-2 text-13 pl-6">
                          {selectedPromotion.everyNth.appliesTo.isCategories &&
                          <>
                            {!!selectedPromotion.everyNth.appliesTo.value.categories.length &&
                              <li>
                                {'Categories: '}
                                {selectedPromotion.everyNth.appliesTo.value.categories.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.everyNth.appliesTo.value.categories.length > 1 &&
                                      selectedPromotion.everyNth.appliesTo.value.categories.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            }
                          </>
                          }
                          {selectedPromotion.everyNth.appliesTo.isListings &&
                            <>
                              <li>
                                {'Listings: '}
                                {selectedPromotion.everyNth.appliesTo.value.listings.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.everyNth.appliesTo.value.listings.length > 1 &&
                                      selectedPromotion.everyNth.appliesTo.value.listings.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            </>
                          }
                        </ul>
                    }
                  </>
                }
                {selectedPromotion.everyNth.notAppliesTo.name !== 'None' &&
                  <>
                    <Typography variant="h5" className="font-bold text-13">
                      Does Not Applies To:
                    </Typography>
                    {
                      (
                        selectedPromotion.everyNth.notAppliesTo.name === 'All Products'
                        || selectedPromotion.everyNth.notAppliesTo.name === 'All Treatments'
                      ) ?
                        <ul className="my-2 text-13 pl-6">
                          <li>{selectedPromotion.everyNth.notAppliesTo.name}</li>
                        </ul>
                        :
                        <ul className="my-2 text-13 pl-6">
                          {selectedPromotion.everyNth.notAppliesTo.isCategories &&
                          <>
                            {!!selectedPromotion.everyNth.notAppliesTo.value.categories.length &&
                              <li>
                                {'Categories: '}
                                {selectedPromotion.everyNth.notAppliesTo.value.categories.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.everyNth.notAppliesTo.value.categories.length > 1 &&
                                      selectedPromotion.everyNth.notAppliesTo.value.categories.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            }
                          </>
                          }
                          {selectedPromotion.everyNth.notAppliesTo.isListings &&
                            <>
                              <li>
                                {'Listings: '}
                                {selectedPromotion.everyNth.notAppliesTo.value.listings.map((v, idx) => (
                                  <span key={v.id}>
                                    {v.name.trim()}
                                    {(
                                      selectedPromotion.everyNth.notAppliesTo.value.listings.length > 1 &&
                                      selectedPromotion.everyNth.notAppliesTo.value.listings.length !== (idx + 1) &&
                                      <>{', '}</>
                                    )}
                                  </span>
                                ))
                                }
                              </li>
                            </>
                          }
                        </ul>
                    }
                  </>
                }
              </>
              }
              {selectedPromotion.bundle.isActive &&
              <>
                {(!!selectedPromotion.bundle.appliesTo.name.length &&
                  !!selectedPromotion.bundle.appliesTo.value.length
                ) &&
                <ul className="my-2 text-13 pl-6">
                  <li>
                    {selectedPromotion.bundle.appliesTo.value.map((v) => v.name.trim()).join(', ')}{' '}
                    {(!!selectedPromotion.bundle.discountValue.name.length &&
                          !!selectedPromotion.bundle.discountValue.value.length
                    ) &&
                    <>
                      {
                        (
                          selectedPromotion.bundle.discountValue.name === 'Percentage OFF'
                                  || selectedPromotion.bundle.discountValue.name === 'Dollar OFF'
                        ) ?
                          <>
                            {'with '}{selectedPromotion.bundle.discountValue.value}{' OFF'}
                          </>
                          :
                          <>
                            {'with fixed price '}{selectedPromotion.bundle.discountValue.value}
                          </>
                      }
                    </>
                    }
                  </li>
                </ul>
                }
              </>
              }
              {selectedPromotion.freeShipping.active &&
                <ul className="my-2 text-13 pl-6">
                  <li>
                    Free Shipping on All Products
                  </li>
                </ul>
              }
            </>
            }
            {!(selectedPromotion.discountType.value === 'buyXGetY'
              || selectedPromotion.discountType.value === 'everyNth') &&
              !!selectedPromotion.minOrderAmount.name.length &&
              <>
                <Typography variant="h5" className="font-bold text-13">
                  Minimum order to qualify
                </Typography>
                <ul className="my-2 text-13 pl-6">
                  <li>
                    {selectedPromotion.minOrderAmount.name === 'None' && 'None'}
                    {selectedPromotion.minOrderAmount.name !== 'None' && selectedPromotion.minOrderAmount.value}
                  </li>
                </ul>
              </>
            }
            {!!selectedPromotion.customerGroups.name.length &&
              <>
                <Typography variant="h5" className="font-bold text-13">
                  Customer Eligibility:
                </Typography>
                <ul className="my-2 text-13 pl-6">
                  {
                    (selectedPromotion.customerGroups.name === 'Everyone') ?
                      <li>
                        Everyone
                      </li>
                      :
                      selectedPromotion.customerGroups.value.map((v) => (
                        <li key={v.id}>
                          {v.code}
                        </li>
                      ))
                  }
                </ul>
              </>
            }
            {(selectedPromotion.usageLimits.shoppingQuantity?.checked
              || selectedPromotion.usageLimits.perCustomer?.checked
            ) &&
              <>
                <Typography variant="h5" className="font-bold text-13">
                  Usage Limits
                </Typography>
                {selectedPromotion.usageLimits.perCustomer?.checked &&
                  <ul className="my-2 text-13 pl-6">
                    <li>
                      Number of times this discount can be used per customer - {selectedPromotion.usageLimits.perCustomer.value}
                    </li>
                  </ul>
                }
                {selectedPromotion.usageLimits.shoppingQuantity?.checked &&
                  <ul className="my-2 text-13 pl-6">
                    <li>
                      Maximum quantity in shopping cart the discount can be applied to - {selectedPromotion.usageLimits.shoppingQuantity.value}
                    </li>
                  </ul>
                }
              </>
            }
            {Object.values(selectedPromotion.exclusionNotes)?.find((el: IExclusionNote) => el?.checked) &&
              <>
                <Typography variant="h5" className="font-bold text-13">
                  Exclusions
                </Typography>

                {Object.values(selectedPromotion.exclusionNotes)?.map((el: IExclusionNote) => el?.checked ?
                  <ul key={el.name} className="my-2 text-13 pl-6">
                    <li>{el.name}</li>
                  </ul>
                  :
                  ''
                )}
              </>
            }
            {(selectedPromotion.dates.startDate) &&
              <>
                <Typography variant="h5" className="font-bold text-13">
                  Active Dates
                </Typography>
                <ul className="my-2 text-13 pl-6">
                  <li>
                    Active from {format(parseISO(selectedPromotion.dates.startDate), 'MM/dd/yyyy')}{' '}
                    <span className="uppercase">
                      {selectedPromotion.dates.startTime}
                    </span>
                    {selectedPromotion.dates.isEndDates && selectedPromotion.dates.endDate && (
                      <>
                        {' to'} {format(parseISO(selectedPromotion.dates.endDate), 'MM/dd/yyyy')}{' '}
                        <span className="uppercase">
                          {selectedPromotion.dates.endTime}
                        </span>
                      </>
                    )}
                  </li>
                </ul>
              </>
            }
            {!!selectedPromotion.uploadFile.length &&
              <>
                <Typography variant="h5" className="font-bold text-13">
                  File Upload
                </Typography>
                <ul className="my-2 text-13 pl-6">
                  {selectedPromotion.uploadFile.map((el) => el.filename &&
                    <li key={el.filename} >{el.filename}</li>
                  )}
                </ul>
              </>
            }
          </>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestedPromotionDetails;
